import { useContext } from 'react';
import { FetchApiContext, } from '../../contexts/fetchApi';
export function useFetchApiOptions() {
    return useContext(FetchApiContext);
}
